module.exports = __webpack_public_path__ + "static/media/blood-help.686f85c8.png";